/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconCrossOff = createReactComponent("cross-off", "IconCrossOff", [
  ["path", { d: "M16 12h3v-4h-5v-5h-4v3m-2 2h-3v4h5v9h4v-7", key: "svg-0" }],
  ["path", { d: "M3 3l18 18", key: "svg-1" }]
]);

export { IconCrossOff as default };
//# sourceMappingURL=IconCrossOff.js.map
